import { BRAND } from "constants/brand";
import { Ring } from "@uiball/loaders";
import "assets/styles/table.scss";
import { useSelector } from "react-redux";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import DeleteItem from "components/Ui/DeleteItem/DeleteItem";
// import useCity from "@hooks/useCity";
import City from "./City/City";
import useCity from "hooks/useCity";
import AddCity from "./AddCity/AddCity";
import EditCity from "./EditCity/EditCity";
import CityWallet from "./CityWallet/CityWallet";
import CityVendorWallet from "./CityVendorWallet/CityVendorWallet";
import CityOperationalSettings from "./CityOperationalSettings/CityOperationalSettings";
import TableColumnsMenu from "components/Ui/TableColumnsMenu/TableColumnsMenu";
import TableHead from "components/Ui/TableHead/TableHead";
import useTableColumnsConfig from "hooks/useTableColumnsConfig";

const COLUMNS = [
    { id: "id", label: "#", width: "10px" },
    { id: "name", label: "الاسم", width: "100px" },
    { id: "topic", label: "الاسم باللغه الانجليزيه", width: "100px" },
    { id: "phone", label: "رقم الهاتف", width: "100px" },
    { id: "location", label: "الموقع", width: "100px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

const Cities = () => {
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showWallet, setShowWallet] = useState(false);
    const [showVendorWallet, setShowVendorWallet] = useState(false);
    const [showOperationalSettings, setShowOperationalSettings] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const { loading, deleteCity } = useCity();
    const navigate = useNavigate();
    const adminInfo = useSelector((state) => state.auth.userData);
    // The same rule as the route of the offers page (App.js).
    const canManageOffers = !!(adminInfo?.super_admin || adminInfo?.roles?.manage_delivery_offers);
    const data = useSelector((state) => state.city.cities);
    const toast = useRef(null);
    const { orderedColumns, visibleColumns, hiddenSet, toggleColumn, moveColumn, reset } =
        useTableColumnsConfig("cities", COLUMNS);

    const showMessage = (type, head, content) => {
        toast.current.show({
            severity: type,
            summary: head,
            detail: content,
            life: 3000,
        });
    };

    const toggleAddForm = () => {
        setShowAddForm((pre) => (pre = !pre));
    };

    const toggleEditForm = () => {
        setShowEditForm((pre) => (pre = !pre));
    };

    const setSelectedRegionValue = (category) => {
        setSelectedRegion(category);
    };

    const toggleDelete = () => {
        setShowDelete((pre) => (pre = !pre));
    };

    const toggleWallet = () => {
        setShowWallet((pre) => (pre = !pre));
    };

    const toggleVendorWallet = () => {
        setShowVendorWallet((pre) => !pre);
    };

    // The two free delivery rules of a city are delivery offers. This opens
    // the offers of the city, where the two are a ready offer each.
    const openDeliveryOffers = (region) => {
        navigate("/delivery-offers", { state: { cityId: region.id } });
    };

    const toggleOperationalSettings = () => {
        setShowOperationalSettings((pre) => (pre = !pre));
    };

    const confirmDelete = async () => {
        try {
            const response = await deleteCity(selectedRegion.id);
            // Assuming `response` contains information to check if the operation succeeded

            if (response) {
                showMessage("warn", "تم الحذف", "تم حذف المنطقه بنجاح");
                toggleDelete();
            } else {
                showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
            }
        } catch (err) {
            console.error("Error adding Area:", err);
            showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
        }
    };

    return (
        <div className="items">
            <Toast style={{ direction: "rtl" }} ref={toast} position="top-left" />

            {loading ? (
                <div className="loadingSpinner">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : (
                <>
                    <div className="controls">
                        <div>
                            <button className="button" onClick={toggleAddForm}>
                                إضافه مدينه
                            </button>
                        </div>
                        <div style={{ marginInlineStart: "auto" }}>
                            <TableColumnsMenu
                                orderedColumns={orderedColumns}
                                hiddenSet={hiddenSet}
                                toggleColumn={toggleColumn}
                                moveColumn={moveColumn}
                                reset={reset}
                            />
                        </div>
                    </div>
                    <div className="table-container">
                        <table>
                            <TableHead visibleColumns={visibleColumns} />
                            <tbody>
                                {data ? (
                                    data.map((region) => (
                                        <City
                                            key={region.id}
                                            region={region}
                                            visibleColumns={visibleColumns}
                                            selectedRegion={selectedRegion}
                                            toggleEditForm={toggleEditForm}
                                            setSelectedRegionValue={setSelectedRegionValue}
                                            toggleDelete={toggleDelete}
                                            toggleWallet={toggleWallet}
                                            toggleVendorWallet={toggleVendorWallet}
                                            openDeliveryOffers={
                                                canManageOffers ? openDeliveryOffers : undefined
                                            }
                                            toggleOperationalSettings={toggleOperationalSettings}
                                        />
                                    ))
                                ) : (
                                    <h4>لا يوجد مدن!</h4>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <AddCity show={showAddForm} close={toggleAddForm} showMessage={showMessage} />
                    <EditCity
                        show={showEditForm}
                        close={toggleEditForm}
                        showMessage={showMessage}
                        region={selectedRegion}
                    />
                    <CityWallet
                        show={showWallet}
                        close={toggleWallet}
                        showMessage={showMessage}
                        region={selectedRegion}
                    />
                    <CityVendorWallet
                        show={showVendorWallet}
                        close={toggleVendorWallet}
                        showMessage={showMessage}
                        region={selectedRegion}
                    />
                    <CityOperationalSettings
                        show={showOperationalSettings}
                        close={toggleOperationalSettings}
                        showMessage={showMessage}
                        region={selectedRegion}
                    />
                    <DeleteItem
                        show={showDelete}
                        close={toggleDelete}
                        loading={loading}
                        confirm={confirmDelete}
                    />
                </>
            )}
        </div>
    );
};
export default Cities;
